import React, { useState, useEffect, useContext } from 'react';
import ReactPlaceholder from 'react-placeholder';
import { Row, InputPlaceholder } from '@contently/toolkit';
import { get, endpoint } from '../../../utils/shared/api';
import EnhancedSelect from './enhanced_select/enhanced_select';
import formatOptions from '../../utils/formatters/formatOptions';
import { handleError } from '../../utils/errors';
import { FormikHandlersContext } from './dynamic_forms/DynamicFormikForm';

function ContentRequestFormSelect(props) {
  const {
    id,
    accountId,
    onFetching,
    onError,
    fetching,
    values,
    errors,
    touched,
    required,
    renderSubtext
  } = props;

  const { setFieldValue, setFieldTouched, fetchingApi, isFetching } = useContext(
    FormikHandlersContext
  );

  const [contentRequestForms, setContentRequestForms] = useState([]);

  async function fetchContentRequestForms() {
    return get(endpoint(`/api/v1/content_request_forms`, { accountId }))
      .then(res => {
        setContentRequestForms(res);
      })
      .catch(error => {
        // fetchingApi.onFetchingError(id);
        // handleError(error);
      })
      .finally(() => {
        fetchingApi.onFetchingComplete(id);
      });
  }

  useEffect(() => {
    fetchContentRequestForms();
  }, []);

  const setValue = (key, value) => {
    setFieldValue(key, value.value);
  };

  if (!contentRequestForms.length) {
    return null;
  }

  return (
    <Row>
      <ReactPlaceholder
        showLoadingAnimation
        customPlaceholder={<InputPlaceholder wrapperClass="row" withLabel />}
        ready={!isFetching}
      >
        <EnhancedSelect
          id={id}
          options={formatOptions(contentRequestForms)}
          label="Content request form"
          placeholder="Select a content request form"
          noTranslate
          selectedValue={values.get(id, null)}
          errors={errors.get(id, [])}
          touched={touched.get(id, false)}
          required={required}
          setFieldTouched={setFieldTouched}
          setFieldValue={setValue}
          renderSubtext={renderSubtext}
          isClearable
        />
      </ReactPlaceholder>
    </Row>
  );
}

export default ContentRequestFormSelect;



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/ContentRequestFormSelect.jsx